import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './Table.css';
import Card from '../Card/Card';
import { Copy } from 'lucide-react';


const Table = () => {
  const TableRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const tCopySnippet = () => {
    if (TableRef.current) {
      const range = document.createRange();
      range.selectNode(TableRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };

  return (

    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="table-sticky">
        <table>
          <thead>
            <tr>
              <th>title 1</th>
              <th>title 2</th>
              <th>title 3</th>
              <th>title 4</th>
              <th>title 5</th>
              <th>title 6</th>
              <th>title 7</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 1</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 2</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 3</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 4</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 5</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 6</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 7</div>
                </div>
              </td>
              <td>
                <div className="button-group">
                  <button className="shadow-off" aria-label="delete">&times;</button>
                  <button className="shadow-off" aria-label="edit">&#9998;</button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 1</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 2</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 3</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 4</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 5</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 6</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 7</div>
                </div>
              </td>
              <td>
                <div className="button-group">
                  <button className="shadow-off" aria-label="delete">&times;</button>
                  <button className="shadow-off" aria-label="edit">&#9998;</button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 1</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 2</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 3</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 4</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 5</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 6</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 7</div>
                </div>
              </td>
              <td>
                <div className="button-group">
                  <button className="shadow-off" aria-label="delete">&times;</button>
                  <button className="shadow-off" aria-label="edit">&#9998;</button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 1</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 2</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 3</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 4</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 5</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 6</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 7</div>
                </div>
              </td>
              <td>
                <div className="button-group">
                  <button className="shadow-off" aria-label="delete">&times;</button>
                  <button className="shadow-off" aria-label="edit">&#9998;</button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 1</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 2</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 3</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 4</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 5</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 6</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 7</div>
                </div>
              </td>
              <td>
                <div className="button-group">
                  <button className="shadow-off" aria-label="delete">&times;</button>
                  <button className="shadow-off" aria-label="edit">&#9998;</button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 1</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 2</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 3</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 4</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 5</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 6</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 7</div>
                </div>
              </td>
              <td>
                <div className="button-group">
                  <button className="shadow-off" aria-label="delete">&times;</button>
                  <button className="shadow-off" aria-label="edit">&#9998;</button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 1</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 2</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 3</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 4</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 5</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 6</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 7</div>
                </div>
              </td>
              <td>
                <div className="button-group">
                  <button className="shadow-off" aria-label="delete">&times;</button>
                  <button className="shadow-off" aria-label="edit">&#9998;</button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 1</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 2</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 3</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 4</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 5</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 6</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 7</div>
                </div>
              </td>
              <td>
                <div className="button-group">
                  <button className="shadow-off" aria-label="delete">&times;</button>
                  <button className="shadow-off" aria-label="edit">&#9998;</button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 1</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 2</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 3</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 4</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 5</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 6</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 7</div>
                </div>
              </td>
              <td>
                <div className="button-group">
                  <button className="shadow-off" aria-label="delete">&times;</button>
                  <button className="shadow-off" aria-label="edit">&#9998;</button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 1</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 2</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 3</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 4</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 5</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 6</div>
                </div>
              </td>
              <td>
                <div className="data-group">
                  <div className="title-medium">value 7</div>
                </div>
              </td>
              <td>
                <div className="button-group">
                  <button className="shadow-off" aria-label="delete">&times;</button>
                  <button className="shadow-off" aria-label="edit">&#9998;</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pre>
        <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

          <div className='snippet' ref={TableRef}>
            <code>
              <span className="cn">&lt;table&gt;</span>
              <br />
              &nbsp;&nbsp;<span className="cn">&lt;thead&gt;</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;tr&gt;</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;th&gt;</span>title 1<span className="cn">&lt;/th&gt;</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;th&gt;</span>title 2<span className="cn">&lt;/th&gt;</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;th&gt;</span>title 3<span className="cn">&lt;/th&gt;</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;th&gt;</span>title 4<span className="cn">&lt;/th&gt;</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;th&gt;</span>title 5<span className="cn">&lt;/th&gt;</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;th&gt;</span>title 6<span className="cn">&lt;/th&gt;</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;th&gt;</span>title 7<span className="cn">&lt;/th&gt;</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;th&gt;</span>Actions<span className="cn">&lt;/th&gt;</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/tr&gt;</span>
              <br />
              &nbsp;&nbsp;<span className="cn">&lt;/thead&gt;</span>
              <br />
              &nbsp;&nbsp;<span className="cn">&lt;tbody&gt;</span>
              <br />

              {Array.from({ length: 10 }).map((_, rowIndex) => (
                <React.Fragment key={rowIndex}>
                  &nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;tr&gt;</span>
                  <br />
                  {Array.from({ length: 7 }).map((_, colIndex) => (
                    <React.Fragment key={colIndex}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;td&gt;</span>
                      <br />
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span>{" "}
                      <span className="cln">class="</span>data-group<span className="cln">"</span><span className="cn">&gt;</span>
                      <br />
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span>{" "}
                      <span className="cln">class="</span>title-medium<span className="cln">"</span><span className="cn">&gt;</span>value {colIndex + 1}
                      <span className="cn">&lt;/div&gt;</span>
                      <br />
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/div&gt;</span>
                      <br />
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/td&gt;</span>
                      <br />
                    </React.Fragment>
                  ))}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;td&gt;</span>
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span>{" "}
                  <span className="cln">class="</span>button-group<span className="cln">"</span><span className="cn">&gt;</span>
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;button</span>{" "}
                  <span className="cln">class="</span>shadow-off<span className="cln">"</span>{" "}
                  <span className="cln">aria-label="</span>delete<span className="cln">"</span>
                  <span className="cn">&gt;<span className='icons'>&#9998;</span>&lt;/button&gt;</span>
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;button</span>{" "}
                  <span className="cln">class="</span>shadow-off<span className="cln">"</span>{" "}
                  <span className="cln">aria-label="</span>edit<span className="cln">"</span>
                  <span className="cn">&gt;<span className='icons'>&#9998;</span>&lt;/button&gt;</span>
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/div&gt;</span>
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/td&gt;</span>
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/tr&gt;</span>
                  <br />
                </React.Fragment>
              ))}
              &nbsp;&nbsp;<span className="cn">&lt;/tbody&gt;</span>
              <br />
              <span className="cn">&lt;/table&gt;</span>



            </code>
          </div>
          <button aria-label="Copy Button" onClick={tCopySnippet}>
            <Copy />
          </button>
        </div>

      </pre>
    </motion.div>

  );
}

const TableCard = () => {

  return (
    <Card
      CardTitle='Table'
      CardBody={<Table />}
    />
  );
}



export default TableCard;
